import './assets/css/styles.scss'
import './style.scss'

import Header from 'components/header'
import Hero from 'components/hero'
import Form from 'components/form'
import Loader from 'components/loader'
import { useClientRequest } from 'hooks/useClientRequest.hook'
import { useEffect, useState } from 'react'
import { useCookie } from 'hooks/useCookie.hook'
import NotFound from 'components/404'
import { computedClass } from 'utils'
import { useService } from 'hooks/useService.hook'
import { useCRMStyles } from './hooks/useCRMStyles.hook'

const PATH = process.env.PUBLIC_URL

const setMetaTag = (name, content) => {
    let tag = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`)
    if (!tag) {
        tag = document.createElement('meta')
        if (name.startsWith('og:')) {
            tag.setAttribute('property', name)
        } else {
            tag.setAttribute('name', name)
        }
        document.head.appendChild(tag)
    }
    tag.setAttribute('content', content)
}

function App({ params = {}, containerEl, wrapperEl }) {
    let { id, full, tilda, popup } = params

    if (/localhost/.test(window.location.origin)) {
        full = true
    }

    const urlParams = new URLSearchParams(window.location.search)
    const [notFound, setNotFound] = useState(full && urlParams.size === 0)
    const formId = id || urlParams.get('id')
    const { getFormScheme } = useClientRequest()
    const { getCompanyByCookie } = useService()
    const { getCookie } = useCookie()
    const [data, setData] = useState()
    const { scheme, event = {}, defaultValues, formData = {} } = data || {}

    const {
        TITLE,
        UF_HIDE_EVENT,
        UF_BACKGROUND,
        UF_LOGOTIP,
        UF_TEXT_SUCCESS,
        UF_POPUP_TITLE,
        UF_TITLE_FORM,
        UF_DESCRIPTION,
        UF_POPUP_SUBTITLE,
        UF_AGREEMENT,
        UF_AGREEMENT_IN_PAGE,
        UF_AGREEMENT_TILDA
    } = formData

    useCRMStyles({ isUseAtTilda: !!tilda, formData, popup, containerEl, formId })

    const prepareSchemeNames = (scheme) => {
        return scheme.map((x) => ({ ...x, name: `FIELD_${x.ID}` }))
    }

    useEffect(() => {
        ;(async () => {
            let { result: { QUESTIONS: scheme, EVENT: event, DATA: formData } = {} } = (await getFormScheme(formId)) || {}
            let defaultValues
            if (scheme) {
                try {
                    scheme = prepareSchemeNames(scheme)
                    const ufCookies = getCookie('ufCookies')
                    if (ufCookies) {
                        const result =(await getCompanyByCookie({ cookies: ufCookies, scheme: formId })) || {};
                        defaultValues = result;
                    }
                } catch (error) {}
                setData({
                    formData,
                    scheme,
                    event,
                    defaultValues,
                })
            } else {
                setNotFound(true)
            }
        })()
    }, [])

    useEffect(() => {
        if (TITLE && full) {
            document.title = TITLE
            setMetaTag('og:type', 'website')
            setMetaTag('og:url', window.location.href)
            setMetaTag('og:title', TITLE)
            setMetaTag('og:image', `${PATH}/og.jpg`)
        }
    }, [TITLE, full])

    const classes = computedClass({
        wrapper: true,
        'wrapper--v2': !full,
    })

    if(notFound && (!tilda && !full)) return null

    return (
        <div className={classes}>
            {full && <Header background={UF_BACKGROUND} logo={UF_LOGOTIP}></Header>}
            <div className="inner">
                <div className="container">
                    <Loader active={!data && !notFound}></Loader>
                    {notFound && !tilda && <NotFound></NotFound>}
                    {!notFound && data && (
                        <>
                            {full && <Hero {...event} TITLE={TITLE} hideEvent={UF_HIDE_EVENT}></Hero>}
                            <Form
                                popup={popup}
                                tilda={tilda}
                                containerEl={containerEl}
                                wrapperEl={wrapperEl}
                                formPopupTitle={UF_POPUP_TITLE}
                                formTitle={UF_TITLE_FORM}
                                formPopupSubTitle={UF_POPUP_SUBTITLE}
                                formSubTitle={UF_DESCRIPTION}
                                successText={UF_TEXT_SUCCESS}
                                initialScheme={scheme}
                                tildaAgreement={UF_AGREEMENT_TILDA}
                                pageIntegrateFormAgreement={UF_AGREEMENT_IN_PAGE}
                                fullFormPageAgreement={UF_AGREEMENT}
                                id={formId}
                                defaultValues={defaultValues}
                                isFullPageForm={full}
                            ></Form>
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default App
